define('models/targetingVendor',["T1", "T1Model"], function (T1, T1Model) {
  "use strict";

  T1.Models.TargetingVendor = T1Model.extend({
    canCache: true,
    url: "targeting_vendors"
  });
  return T1.Models.TargetingVendor;
});
